import axios from "axios";
import { useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";

export default function Logout() {
  const navigate = useNavigate();

  const serverFolder = localStorage.getItem("server_folder");
  const serverUrl = localStorage.getItem("server_url");
  const login_url = localStorage.getItem("login_url");
  const dealerId = localStorage.getItem("dealer_id");
  const token = localStorage.getItem("token");

  const checkUser = useCallback(async () => {
    try {
      const formData = new FormData();
      formData.append("company_id", "2");
      formData.append("dealer_id", dealerId);
      formData.append("check_device_token", token);

      const res = await axios.post(
        `${serverUrl}dealer_logout_web.php`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
    } catch (error) {
      console.error("Logout error:", error);
    } finally {
      // Clear localStorage *after* logout API call
      localStorage.clear();

      // Restore essential values
      if (serverFolder) localStorage.setItem("server_folder", serverFolder);
      if (serverUrl) localStorage.setItem("server_url", serverUrl);
      if (serverUrl) localStorage.setItem("login_url", login_url);
      navigate("/Login");
    }
  }, [dealerId, token, serverFolder, serverUrl]);

  useEffect(() => {
    checkUser();
  }, [checkUser]);

  return (
    <></>
  );
}
